import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "detail cf pdg",
  "data-pdgb": "80"
}
const _hoisted_3 = { class: "cart" }
const _hoisted_4 = { class: "table" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "product" }
const _hoisted_8 = { class: "qty" }
const _hoisted_9 = { class: "price" }
const _hoisted_10 = { class: "total" }
const _hoisted_11 = { class: "rows" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "product cf" }
const _hoisted_14 = {
  key: 0,
  class: "image"
}
const _hoisted_15 = ["href"]
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "desc" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "variant" }
const _hoisted_20 = { class: "label" }
const _hoisted_21 = { class: "cod" }
const _hoisted_22 = { class: "qty cf" }
const _hoisted_23 = { class: "input" }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = {
  key: 0,
  class: "nav"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 1,
  class: "nav"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "label" }
const _hoisted_31 = { class: "price" }
const _hoisted_32 = { class: "unit" }
const _hoisted_33 = { class: "total" }
const _hoisted_34 = { class: "unit" }
const _hoisted_35 = { class: "remove" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "input" }
const _hoisted_38 = { class: "control" }
const _hoisted_39 = ["aria-label", "placeholder"]
const _hoisted_40 = {
  class: "calltoaction",
  "data-color": "greyl"
}
const _hoisted_41 = {
  key: 1,
  class: "button disable-on-submit"
}
const _hoisted_42 = { class: "note" }
const _hoisted_43 = {
  key: 0,
  class: "discount"
}
const _hoisted_44 = { class: "description" }
const _hoisted_45 = {
  key: 0,
  class: "total"
}
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "unit" }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = {
  key: 1,
  class: "alert"
}
const _hoisted_50 = { class: "footer" }
const _hoisted_51 = { class: "valid-summary" }
const _hoisted_52 = { class: "footer-data" }
const _hoisted_53 = { class: "data" }
const _hoisted_54 = { class: "total" }
const _hoisted_55 = { class: "unit" }
const _hoisted_56 = {
  id: "CartTotal",
  class: "value"
}
const _hoisted_57 = {
  key: 0,
  class: "minimumtotal"
}
const _hoisted_58 = {
  key: 1,
  class: "minimumtotalgap"
}
const _hoisted_59 = {
  key: 0,
  class: "shipping"
}
const _hoisted_60 = {
  class: "shipping-cost",
  "data-free": "true"
}
const _hoisted_61 = {
  class: "calltoaction",
  "data-size": "big"
}
const _hoisted_62 = {
  key: 1,
  class: "button disable-on-submit"
}
const _hoisted_63 = {
  key: 1,
  class: "detail app-width cf pdg",
  "data-pdgb": "80"
}
const _hoisted_64 = { class: "title" }
const _hoisted_65 = {
  class: "subtitle mrg",
  "data-mrgt": "20",
  "data-line": "false"
}
const _hoisted_66 = {
  class: "mrg",
  "data-mrgt": "40"
}
const _hoisted_67 = ["innerHTML"]

import { ref, computed, onUpdated, nextTick } from "vue";
import { useStore } from "vuex";
import Axios from "axios";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'CartDetail',
  setup(__props) {

const store = useStore();

const localizer = Localizer;
const routes = (window as any).App.routes;

const validationErrors = ref<any[]>([]);
const isLoadingForm = ref(false);
const isGAEventSent = ref(false);
const couponCode = ref<string>(null);

const cart = computed(() => {
    let cartData = store.getters["cartStore/cart"];

    couponCode.value = cartData ? cartData.couponCode : null;

    return cartData;
});

function formatPrice(data: string) {
    return Number(data).toFixed(2).replace(".", ",");
}

function addQuantity(cartRow: any) {
    cartRow.quantity = Number(cartRow.quantity);

    if (cartRow.quantity) {
        cartRow.quantity += cartRow.bundleSize;
    } else {
        cartRow.quantity = cartRow.bundleSize;
    }
    if (cartRow.quantity > 1000) {
        cartRow.quantity = 1000;
    }
}

function removeQuantity(cartRow: any) {
    cartRow.quantity = Number(cartRow.quantity);

    if (cartRow.quantity) {
        cartRow.quantity -= cartRow.bundleSize;
    } else {
        cartRow.quantity = cartRow.bundleSize;
    }
    if (cartRow.quantity < 1) {
        cartRow.quantity = cartRow.bundleSize;
    }
}

async function updateQuantity(cartRow: any) {
    FormHelper.removeFocus();

    isLoadingForm.value = true;

    validationErrors.value = [];

    try {
        let response = (await Axios.post(routes.Cart_UpdateQuantity, { cartRowCode: cartRow.cartRowCode, quantity: cartRow.quantity })).data;

        store.commit("cartStore/setCart", response.cartInfo);
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoadingForm.value = false;
}

async function remove(cartRow: any) {
    FormHelper.removeFocus();

    isLoadingForm.value = true;

    validationErrors.value = [];

    try {
        let response = (await Axios.post(routes.Cart_RemoveProduct, { cartRowCode: cartRow.cartRowCode })).data;

        store.commit("cartStore/setCart", response.cartInfo);

        GTagHelper.sendCustomEvent("remove_from_cart", {
            currency: "EUR",
            value: parseFloat(cartRow.UnitPrice.replace(',', '.')) * cartRow.quantity,
            items: [
                {
                    item_id: cartRow.productCode,
                    item_name: cartRow.productTitle,
                    affiliation: "Technical Ceramic",
                    currency: "EUR",
                    item_category: cartRow.categoryName,
                    price: parseFloat(cartRow.unitPrice.replace(',', '.')),
                    quantity: cartRow.quantity
                }
            ]
        });
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoadingForm.value = false;
}

async function setCouponCode() {
    FormHelper.removeFocus();

    isLoadingForm.value = true;

    validationErrors.value = [];

    try {
        const response = (await Axios.post(routes.Cart_SetCouponCode, { couponCode: couponCode.value })).data;

        store.commit("cartStore/setCart", response.cartInfo);
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoadingForm.value = false;
}

async function checkout() {
    FormHelper.removeFocus();

    validationErrors.value = [];

    isLoadingForm.value = true;

    try {
        await Axios.post(routes.Cart_Checkout, { couponCode: couponCode.value });

        window.location = routes.Checkout_Summary;
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoadingForm.value = false;
}

onUpdated(() => {
    nextTick(() => {
        if (cart.value && !isGAEventSent.value) {
            var itemList = [];

            for (var cartRow in cart.value.cartRows) {
                itemList.push({
                    item_id: cart.value.cartRows[cartRow].productCode,
                    item_name: cart.value.cartRows[cartRow].productTitle,
                    affiliation: "Technical Ceramic",
                    currency: "EUR",
                    item_category: cart.value.cartRows[cartRow].categoryName,
                    price: parseFloat(cart.value.cartRows[cartRow].unitPrice.replace(',', '.')),
                    quantity: cart.value.cartRows[cartRow].quantity
                });
            }

            GTagHelper.sendCustomEvent("view_cart", {
                currency: "EUR",
                value: parseFloat(cart.value.cartTotalWithCosts.replace(',', '.')),
                items: itemList
            });

            isGAEventSent.value = true;
        }
    });
});

return (_ctx: any,_cache: any) => {
  const _component_shippingcosts_preview = _resolveComponent("shippingcosts-preview")!

  return (cart.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (cart.value.cartQuantity !== 0)
          ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("table", _hoisted_4, [
                  _createElementVNode("thead", _hoisted_5, [
                    _createElementVNode("tr", _hoisted_6, [
                      _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(localizer).get("Checkout.Common.ProductDescription")), 1),
                      _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(localizer).get("Checkout.Common.Quantity")), 1),
                      _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(localizer).get("Checkout.Common.Price")), 1),
                      _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(localizer).get("Checkout.Common.Total")), 1),
                      _cache[4] || (_cache[4] = _createElementVNode("td", { class: "remove" }, null, -1))
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cart.value.cartRows, (cartRow) => {
                    return (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                      _createElementVNode("tr", _hoisted_12, [
                        _createElementVNode("td", _hoisted_13, [
                          (cartRow.productImageUrl)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("a", {
                                  href: cartRow.productUrl
                                }, [
                                  _createElementVNode("img", {
                                    src: cartRow.productImageUrl,
                                    width: "100",
                                    height: "100",
                                    alt: "",
                                    loading: "lazy"
                                  }, null, 8, _hoisted_16)
                                ], 8, _hoisted_15)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("a", {
                              href: cartRow.productUrl,
                              class: "title"
                            }, _toDisplayString(cartRow.productTitle), 9, _hoisted_18),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("span", _hoisted_20, _toDisplayString(cartRow.variantTitle), 1),
                              _createTextVNode(_toDisplayString(cartRow.variantDescription), 1)
                            ]),
                            _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(localizer).get("Checkout.Common.Cod")) + " " + _toDisplayString(cartRow.productCode), 1)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _withDirectives(_createElementVNode("input", {
                              name: "Quantity",
                              type: "number",
                              class: "textbox",
                              "onUpdate:modelValue": ($event: any) => ((cartRow.quantity) = $event)
                            }, null, 8, _hoisted_24), [
                              [_vModelText, cartRow.quantity]
                            ]),
                            (!isLoadingForm.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  _createElementVNode("button", {
                                    class: "button fastic-angle-up",
                                    "data-type": "add",
                                    onClick: ($event: any) => (addQuantity(cartRow))
                                  }, null, 8, _hoisted_26),
                                  _createElementVNode("button", {
                                    class: "button fastic-angle-down",
                                    "data-type": "remove",
                                    onClick: ($event: any) => (removeQuantity(cartRow))
                                  }, null, 8, _hoisted_27)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_28, [...(_cache[5] || (_cache[5] = [
                                  _createElementVNode("button", {
                                    class: "button fastic-angle-up",
                                    "data-type": "add"
                                  }, null, -1),
                                  _createElementVNode("button", {
                                    class: "button fastic-angle-down",
                                    "data-type": "remove"
                                  }, null, -1)
                                ]))]))
                          ]),
                          (!isLoadingForm.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "update disable-on-submit",
                                onClick: ($event: any) => (updateQuantity(cartRow))
                              }, [
                                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "icon fastic-refresh" }, null, -1)),
                                _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(localizer).get("Checkout.Common.Update")), 1)
                              ], 8, _hoisted_29))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_31, [
                          _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(localizer).get("Catalogue.Common.Euro")), 1),
                          _createTextVNode(_toDisplayString(cartRow.unitPrice), 1)
                        ]),
                        _createElementVNode("td", _hoisted_33, [
                          _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(localizer).get("Catalogue.Common.Euro")), 1),
                          _createTextVNode(_toDisplayString(cartRow.rowPrice), 1)
                        ]),
                        _createElementVNode("td", _hoisted_35, [
                          (!isLoadingForm.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "button disable-on-submit zmdi zmdi-delete",
                                onClick: ($event: any) => (remove(cartRow))
                              }, [...(_cache[7] || (_cache[7] = [
                                _createElementVNode("span", { class: "icon fastic-trash" }, null, -1)
                              ]))], 8, _hoisted_36))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 256))
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["coupon", { active: cart.value.isCoupon }])
                }, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((couponCode).value = $event)),
                        id: "CouponCode",
                        name: "CouponCode",
                        type: "text",
                        "aria-label": _unref(localizer).get('Checkout.Common.InsertCoupon'),
                        placeholder: _unref(localizer).get('Checkout.Common.InsertCoupon'),
                        onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (setCouponCode()), ["prevent","stop"]), ["enter"])),
                        class: "input textbox disable-on-submit",
                        maxlength: "50"
                      }, null, 40, _hoisted_39), [
                        [
                          _vModelText,
                          couponCode.value,
                          void 0,
                          { lazy: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      (!isLoadingForm.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "button disable-on-submit",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (setCouponCode()))
                          }, _toDisplayString(_unref(localizer).get("Checkout.Common.Apply")), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_unref(localizer).get("Checkout.Common.Apply")), 1))
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("em", null, _toDisplayString(_unref(localizer).get("Checkout.Common.CouponDisclaimer")), 1)
                    ])
                  ]),
                  (cart.value.isCoupon)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("em", null, _toDisplayString(cart.value.couponDescription), 1)
                        ]),
                        (cart.value.couponDiscount !== 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              (cart.value.couponDiscountMode === 'Amount')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                                    _createElementVNode("span", _hoisted_47, _toDisplayString(_unref(localizer).get("Catalogue.Common.Euro")), 1),
                                    _createTextVNode("-" + _toDisplayString(formatPrice(cart.value.couponDiscount)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (cart.value.couponDiscountMode === 'Percentage')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                                    _createTextVNode(" -" + _toDisplayString(cart.value.couponDiscount), 1),
                                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "unit" }, "%", -1))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (cart.value.couponMinimumCartTotal && cart.value.couponMinimumGap !== 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_unref(localizer).get("Checkout.Common.CouponGap_Start")) + " " + _toDisplayString(formatPrice(cart.value.couponMinimumGap)) + " " + _toDisplayString(_unref(localizer).get("Checkout.Common.CouponGap_End")), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                      return (_openBlock(), _createElementBlock("div", null, _toDisplayString(validationError.message), 1))
                    }), 256))
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createVNode(_component_shippingcosts_preview),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createTextVNode(_toDisplayString(_unref(localizer).get("Checkout.Common.TotalIva")) + " ", 1),
                        _createElementVNode("span", _hoisted_55, _toDisplayString(_unref(localizer).get("Catalogue.Common.Euro")), 1),
                        _createElementVNode("span", _hoisted_56, _toDisplayString(cart.value.cartTotal), 1)
                      ]),
                      (cart.value.minimumTotalGap)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_unref(localizer).get("Checkout.Common.MinimumTotal")) + " " + _toDisplayString(cart.value.minimumOrderTotal), 1))
                        : _createCommentVNode("", true),
                      (cart.value.minimumTotalGap)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_unref(localizer).get("Checkout.Common.MinimumTotalGap_Start")) + " " + _toDisplayString(cart.value.minimumTotalGap) + " " + _toDisplayString(_unref(localizer).get("Checkout.Common.MinimumTotalGap_End")), 1))
                        : _createCommentVNode("", true),
                      (cart.value.shippingMode != 'ExWork')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (cart.value.isFreeShippingCosts)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                  _createElementVNode("div", _hoisted_60, _toDisplayString(_unref(localizer).get("Checkout.Common.FreeShipping")), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_61, [
                        (!isLoadingForm.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "button disable-on-submit",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (checkout()))
                            }, _toDisplayString(_unref(localizer).get("Checkout.Common.CompleteOrder")), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_unref(localizer).get("Checkout.Common.CompleteOrder")), 1))
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("section", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, _toDisplayString(_unref(localizer).get("Checkout.Common.Empty_Title")), 1),
              _createElementVNode("div", _hoisted_65, _toDisplayString(_unref(localizer).get("Checkout.Common.Empty_Abstract")), 1),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("span", {
                  innerHTML: _unref(localizer).get('Checkout.Common.Empty_Description', _unref(routes).Account_Login, _unref(localizer).get('Checkout.Common.Empty_Link'))
                }, null, 8, _hoisted_67)
              ])
            ]))
      ]))
    : _createCommentVNode("", true)
}
}

})